/**
 * Create a deep clone of an object
 * @param obj Object to clone
 * @returns Cloned object
 */
export default function clone(obj: any) {
  return JSON.parse(JSON.stringify(obj))
}
